import type { InjectionKey, MaybeRefOrGetter } from "vue";

/** The rich text editors SCARichText can show: TinyMCE, or Tiptap while the new editor is tested. */
export type RichTextEngine = "tinymce" | "tiptap";

/**
 * Which editor rich text opens in; the app provides the user's profile setting, TinyMCE when nothing is provided.
 * `undefined` while the setting loads: the editor waits for it, so TinyMCE is not loaded for a user who picked Tiptap.
 */
export const SCA_RICH_TEXT_ENGINE: InjectionKey<MaybeRefOrGetter<RichTextEngine | undefined>> =
  Symbol("richTextEngine");
